export default "__VITE_ASSET__C0CE_ZQ3__"